import profile from 'iztech-design-system-neo/dist/system/i18n/vi/profile'

export default {
  ...profile,
	MSG_UPDATE_FAIL: 'Cập nhật thất bại!',
	MSG_UPDATE_SUCCESS: 'Cập nhật thành công!',
  MSG_DATA_VALIDATOR: 'Vui lòng kiểm tra lại thông tin!',
	MSG_INVALID_SIGNED_USER: 'Bạn chưa đăng nhập, vui lòng đăng nhập để thao tác!',
}